<div class="liquidacion-detalle-card" [formGroup]="detalleFormGroup" #localDetalleForm="ngForm">
	<div class="liquidacion-detalle-card__index">{{ detalleNumero }}</div>
	<div class="liquidacion-detalle-card__fields">
		<div class="liquidacion-detalle-field liquidacion-detalle-field--code">
			<label for="documento-codigo-{{ detalleNumero }}">Código</label>
			<input id="documento-codigo-{{ detalleNumero }}" type="text" class="form-control" formControlName="codigo" (blur)="onSubmit()" />
			<div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.codigo.invalid" class="text-danger">
				<div *ngIf="detalleFormGroup.controls.codigo.errors?.required">Campo requerido</div>
			</div>
		</div>

		<div class="liquidacion-detalle-field liquidacion-detalle-field--name">
			<label for="documento-nombre-{{ detalleNumero }}">Nombre</label>
			<input id="documento-nombre-{{ detalleNumero }}" type="text" class="form-control" formControlName="nombreItem" (blur)="onSubmit()" />
			<div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.nombreItem.invalid" class="text-danger">
				<div *ngIf="detalleFormGroup.controls.nombreItem.errors?.required">Campo requerido</div>
			</div>
		</div>

		<div class="liquidacion-detalle-field liquidacion-detalle-field--quantity">
			<label for="documento-cantidad-{{ detalleNumero }}">Cant.</label>
			<input id="documento-cantidad-{{ detalleNumero }}" type="number" min="1" class="form-control" formControlName="cantidad" (blur)="onSubmit()" />
			<div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.cantidad.invalid" class="text-danger">
				<div *ngIf="detalleFormGroup.controls.cantidad.errors?.required">Campo requerido</div>
				<div *ngIf="detalleFormGroup.controls.cantidad.errors?.PositiveNumber">Número debe ser positivo</div>
			</div>
		</div>

		<div class="liquidacion-detalle-field liquidacion-detalle-field--total">
			<label for="documento-total-{{ detalleNumero }}">Precio</label>
			<input id="documento-total-{{ detalleNumero }}" type="text" inputmode="decimal" appPrecioMiles class="form-control" formControlName="precioUnitario" (blur)="onSubmit()" />
			<div class="text-danger" *ngIf="detalleFormGroup.controls.precioUnitario.touched && detalleFormGroup.controls.precioUnitario.errors?.precioFormato">Use puntos para miles y coma para decimales.</div>
			<div class="clp-equivalent text-right mt-1" *ngIf="opciones.tipoMoneda != 'CLP'">CLP {{ subPrice | number : '1.0-2' : 'es' }}</div>
		</div>

		<div class="liquidacion-detalle-field liquidacion-detalle-field--exempt">
			<label for="documento-exento-{{ detalleNumero }}">Exento</label>
			<div class="custom-control custom-checkbox">
				<input id="documento-exento-{{ detalleNumero }}" type="checkbox" class="custom-control-input" formControlName="exento" (blur)="onSubmit()" />
				<label class="custom-control-label" for="documento-exento-{{ detalleNumero }}" aria-hidden="true"></label>
			</div>
		</div>

		<div class="liquidacion-detalle-field liquidacion-detalle-field--subtotal">
			<label>Subtotal</label>
			<div class="liquidacion-detalle-field__subtotal-row">
				<div class="liquidacion-detalle-field__subtotal-value">
					<ng-container *ngIf="opciones.tipoMoneda != 'CLP'; else subtotalClp">
						<input type="text" class="form-control liquidacion-detalle-field__subtotal" readonly tabindex="-1" [value]="totalForeign | number : '1.0-2' : 'es'" />
						<div class="clp-equivalent text-right mt-1">CLP {{ detalleDte.total | number : '1.0-2' : 'es' }}</div>
					</ng-container>
					<ng-template #subtotalClp>
						<input type="text" class="form-control liquidacion-detalle-field__subtotal" readonly tabindex="-1" [value]="detalleDte.total | number : '1.0-2' : 'es'" />
					</ng-template>
				</div>
				<button type="button" class="btn btn-sm btn-light-danger liquidacion-detalle-field__delete" (click)="deleteItem()" title="Eliminar línea">
					<i class="flaticon-delete"></i>
				</button>
			</div>
		</div>
	</div>

	<details class="liquidacion-detalle-card__description detalle-adicionales" *ngIf="showingDetails" [open]="adicionalesAbiertos" (toggle)="adicionalesAbiertos = $any($event.target).open">
		<summary class="detalle-adicionales__encabezado">
			<span>Descripción, descuentos y datos adicionales</span>
			<span class="detalle-adicionales__flecha" aria-hidden="true"></span>
		</summary>

		<div class="liquidacion-detalle-card__description-field">
			<label for="documento-descripcion-{{ detalleNumero }}">Descripción</label>
			<textarea id="documento-descripcion-{{ detalleNumero }}" class="form-control" formControlName="descripcion" rows="2" (blur)="onSubmit()"></textarea>
			<div *ngIf="localDetalleForm.touched && detalleFormGroup.controls.descripcion.invalid" class="text-danger">
				<div *ngIf="detalleFormGroup.controls.descripcion.errors?.required">Campo requerido</div>
			</div>
		</div>
        <div class="liquidacion-detalle-card__extras">
		<div class="liquidacion-detalle-field liquidacion-detalle-field--discount">
			<label for="documento-descuento-{{ detalleNumero }}">Descuento</label>
			<input id="documento-descuento-{{ detalleNumero }}" type="number" class="form-control" formControlName="descuento" (blur)="onSubmit()" />
			<div class="clp-equivalent text-right mt-1" *ngIf="opciones.tipoMoneda != 'CLP'">CLP {{ subDiscount | number : '1.0-2' : 'es' }}</div>
		</div>

		<div class="liquidacion-detalle-field liquidacion-detalle-field--recharge">
			<label for="documento-recargo-{{ detalleNumero }}">Recargo</label>
			<input id="documento-recargo-{{ detalleNumero }}" type="number" class="form-control" formControlName="recargo" (blur)="onSubmit()" />
			<div class="clp-equivalent text-right mt-1" *ngIf="opciones.tipoMoneda != 'CLP'">CLP {{ subRecharge | number : '1.0-2' : 'es' }}</div>
		</div>

        </div>
	</details>
</div>

<swal #currentSwal title="Operación" text="Operación realizada" icon="info" style="z-index: 900000 !important;"></swal>
